import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import { getReserveInfo } from '../../../const';
import messageConst from '../../../const/messageConst';
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { InputText } from '../../atoms/inputText';
import { Label } from '../../atoms/label';
import { ModalClose } from "../../atoms/modalClose";
import { ErrorMassage } from '../../molecules/errorMassage';
import { Loading } from '../../molecules/loading';
import './../../../resources_membership_hotel/css/popup/popup.css';

const MembershipReservationPopupContainer = (props) => {
    const {
        state,
        onClickClosePopupWindow,
        membershipReserveComf,
        setMembershipReserveComf,
        setMembershipReserveInfo,
        setMembershipSearchParam,
        setImportedReserveComf,
        setMembershipCancelReserveComf,
        onClickOpenCancelPopupWindow,
    } = props;

    const store = useStore();
    const login = store.getState().login;
    const loginType = login.loginType;
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    let footerClass = "";
    const popupRef = useRef(null);
    moment.locale('ja')
    const [errorInfo, setErrorInfo] = useState({ errorMessage: [], errorFlg: false });
    const [errorList, setErrorList] = useState([]);
    const importedFlg = !!state.importedFlg;
    const loadingFlg = state.loadingFlg;

    footerClass = "reservation";

    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    }, []);

    const onClose = () => {
        onClickClosePopupWindow();
        setPopupMessage('');
        setErrorList([]);
        popupRef.current.scrollTop = 0;
    }

    // 予約内容取得後処理
    const afterGetReserveInfo = (res, ref) => {
        const {resultCode, errorMessage, reserveInfo} = res.data;
        let errMsg = null;
        // バックエンドエラー
        if (resultCode != 0) {
            errMsg = errorMessage;
        }
        // 予約取得件数0件
        if (!errMsg && !reserveInfo) {
            errMsg = messageConst.SEARCH_RESV_NOT_FOUND_ERROR;
        }
        if (errMsg) {
            if (ref.type == "membership") {
                const reserveCnt = state.reservationConfList.reserveList.length;
                let newErrorList = [];
                for (let i = 0; i < reserveCnt; i++) {
                    if (i == ref.errIndex) {
                        newErrorList.push({ errorMessage: [errMsg], errorFlg: true });
                    } else {
                        newErrorList.push({ errorMessage: [], errorFlg: false });
                    }
                }
                setErrorList(newErrorList);
                setErrorInfo({errorMessage: [], errorFlg: false})
            } else {
                setErrorList([]);
                setErrorInfo({errorMessage: [errMsg], errorFlg: true})
            }
            return;
        }
        // 予約内容が取得できた場合は予約内容確認画面へ遷移
        if (ref.importedFlg) {
            setImportedReserveComf(reserveInfo);
            history.push("/reserve/hotel/importedBookingConfirmDetail")
        } else {
            setMembershipSearchParam({ keiyakuNo: reserveInfo.keiyakuNo, riyoKaiinkenSyubetCd: reserveInfo.riyoKaiinkenSyubetCd });
            setMembershipReserveComf(reserveInfo);
            history.push("/reserve/hotel/hotelBookingConfirmDetail")
        }
        onClose();
        setErrorList([])
        setErrorInfo({errorMessage: [], errorFlg: false})
    }

    // 予約確認
    const onClickConfirm = (res, index, type) => {
        // 予約内容取得
        // let yoyakuNo = "";
        const ref = { errIndex: index, type: type, importedFlg: importedFlg}
        if (type === "membership") {
            setMembershipReserveInfo({ generalFlg: false, cancelKbn: res.cancelKbn });
            let cornerBunKbn = importedFlg ? res.cornerBunKbn : null
            common.doPostRef(getReserveInfo, { yoyakuNo: res.yoyakuNo, generalFlg: false, importedFlg: importedFlg, cornerBunKbn: cornerBunKbn}, ref, afterGetReserveInfo);
        // } else if (type === "general") {
        //     yoyakuNo = document.getElementById("ippanYoyakuNo").value;
        //     setMembershipReserveInfo({ generalFlg: true, cancelKbn: res.cancelKbn });
        //     common.doPostRef(getReserveInfo, { yoyakuNo: yoyakuNo, generalFlg: true }, ref, afterGetReserveInfo);
        // } else if (type === "esthetic") {
        //     yoyakuNo = document.getElementById("estheticYoyakuNo").value;
        //     setMembershipReserveInfo({ generalFlg: true, cancelKbn: res.cancelKbn });
            // commxon.doPost(getReserveInfo, { yoyakuNo: yoyakuNo, generalFlg: true }, afterGetReserveInfo);
        }

    }
    // // 予約キャンセル
    // const onClickCancel = (req) => {
    //     setMembershipCancelReserveComf(req);
    //     onClose();
    //     onClickOpenCancelPopupWindow();
    // }

    const dateForm = (res) => {
        let date = res.substr(0, 4) + "年";
        if (res.substr(5, 1) === '0') {
            date = date + res.substr(6, 1) + "月";
        } else {
            date = date + res.substr(5, 2) + "月";
        }

        if (res.substr(8, 1) === '0') {
            date = date + res.substr(9, 1) + "日";
        } else {
            date = date + res.substr(8, 2) + "日";
        }

        return date;
    }

    return (
        <div className={state.membershipReservationConfPopup ? "popupIsShow reservePopUpIsShow" : "popup"} id="js-popup">
            {loadingFlg ?
                <Loading
                    width={50}
                    height={50}
                    type={"spin"}
                    color={"white"}
                    wrapperClass="membership_loading"
                /> : null
            }
            <div ref={popupRef} className={isMobilePhone ? "popupInner_GOLF_reserveConfirm_media" : "popupInner_GOLF_reserveConfirm"}>
                <div className={isMobilePhone ? "popupSpHead" : "popupPcHead"}>
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClose()} />
                    <h4 className="popupInnerText innerText" >予約確認・変更・キャンセル</h4>
                </div>
                <div style={{ height: "67px" }} />
                {popupMessage !== '' && popupMessage !== undefined ?
                    <div style={style.message}> {popupMessage}</div>
                    :
                    null
                }
                {
                    // 予約が0件の場合
                    (state.reservationConfList === undefined || state.reservationConfList.reserveList === undefined) &&
                    <div className='noDataStyle'>
                        {messageConst.SEARCH_RESV_ERROR}
                    </div>
                }
                <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                    <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
                </div>
                {state.reservationConfList !== undefined && state.reservationConfList.length !== 0 && state.reservationConfList.reserveList !== undefined ? state.reservationConfList.reserveList.map((value, index) => {
                    return <div key={"bookConfirm" + index}
                        style={index === (state.reservationConfList.length - 1) ?
                            { background: "#fff", padding: "30px 0px 60px 0px" }
                            :
                            { background: "#fff", padding: "30px 0px 30px 0px" }
                        }>
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            <div key={"facility" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                {importedFlg ?
                                    <>
                                        <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>レストラン名</div>
                                        <div style={style.inline}>
                                            <div>{value.shisetsuName}</div>
                                            <div>{value.restaurantName}</div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>宿泊ホテル</div>
                                        <div style={style.inline}>{value.shisetsuName}</div>
                                    </>
                                }
                            </div>
                            <div key={"checkIn" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                {importedFlg ?
                                    <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>ご利用日</div>
                                    :
                                    <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>チェックイン</div>
                                }
                                <div style={style.inline}>{dateForm(value.checkInDate)}</div>
                            </div>
                            {importedFlg ? null
                                :
                                <div key={"hakuCnt" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                    <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>泊数</div>
                                    <div style={style.inline}>{value.hakuCnt + "泊"}</div>
                                </div>
                            }
                            <div key={"yoyakuNo" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>予約番号</div>
                                <div style={style.inline}>{value.yoyakuNo}</div>
                            </div>
                            {loginType === "CRAWL" ?
                                <div key={"yoyakuNo" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                    <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>会員番号</div>
                                    <div style={style.inline}>{value.ownerNo}</div>
                                </div> : null
                            }
                            {loginType === "CRAWL" ?
                                <div key={"yoyakuNo" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                    <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>会員名</div>
                                    <div style={style.inline}>{value.kaiinNamKn} / {value.kaisyaNamkn}</div>
                                </div> : null
                            }
                            <div key={"yoyakuJoukyou" + index} style={value.cancelKbn != "1" || value.matiKbn !== "0" ? isMobilePhone ? style.tableRowSp : style.tableRowInfo : {}}
                                className={value.cancelKbn != "1" || value.matiKbn !== "0" ? "" : "hiddenItem"}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>予約状況</div>
                                {value.cancelKbn != "1" ?
                                    <div style={style.inline}>キャンセル</div>
                                    :
                                    <div style={style.inline}>待ちあり</div>
                                }
                            </div>
                            <div style={errorList[index]?.errorFlg ? style.errorDiv : { display: "none" }}>
                                <ErrorMassage style={style.errorMassage} data={errorList[index]?.errorMessage} />
                            </div>
                            <div className="buttonArea3" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                                {/* <Button className={ value.cancelKbn === "1" ? "membership_reservationCancelBtn" : "membership_reservationCancelBtn hiddenItem" } buttonClassName="buttonText" onClick={() => onClickCancel(value)} buttonText="予約を取消" /> */}
                                <Button className="membership_reservationConfirmBtn" buttonClassName="buttonText" onClick={() => onClickConfirm(value, index, "membership")} buttonText="予約内容の確認・変更・キャンセル" />
                            </div>
                        </div>
                    </div>
                }) :
                    null
                    // <div style={{ width: "80%", margin: "0px auto" }}>
                    //     <Label className="membership_RsvConfLabelGeneral" label="一般ホテルのご予約は予約番号を入力ください" />
                    //     <div className="membership_RsvConfbuttonAreaGeneral" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                    //         <InputText className="membership_RsvConfPopupInput" id="ippanYoyakuNo" />
                    //         <Button className="membership_reservationConfirmBtnGeneral" buttonClassName="buttonText" onClick={() => onClickConfirm("", 0, "general")} buttonText="予約内容を確認" />
                    //     </div>
                    //     <Label className="membership_RsvConfLabelEsthetic" label="レストラン・エステのご予約は予約番号を入力ください" />
                    //     <div className="membership_RsvConfbuttonAreaEsthetic" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                    //         <InputText className="membership_RsvConfPopupInput" id="estheticYoyakuNo" />
                    //         <Button className="membership_reservationConfirmBtnGeneral" buttonClassName="buttonText" onClick={() => onClickConfirm("", "esthetic")} buttonText="予約内容を確認" />
                    //     </div>
                    // </div>
                }
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

const style = {
    table: {
        display: "block",
        width: "70%",
        margin: "0px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background: "white",
        marginBottom: "0px",
    },
    tableMobile: {
        display: "block",
        width: "90%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background: "white",
        marginBottom: "0px",
    },
    tableRowSp: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    tableRowInfo: {
        display: "flex",
        alignItems: "center",
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        fontSize: "15px",
        letterSpacing: "1px",
        margin: "0px 40px",
    },
    tableColHeading: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontSize: "small",
        width: "20%"
    },
    tableColHeadingMob: {
        fontWeight: "bold",
        fontSize: "small",
        marginBottom: "5px"
    },
    inline: {
        display: "inline-block",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "center",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    displayNone: {
        display: "none",
    }
}
const mapStateToProps = (state) => {
    return {
        membershipReserveComf: state.membershipReserveComf,
    };
};

const mapDisptchToProps = (dispatch) => {
    return {
        setMembershipReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_COMF", payload: { membershipReserveComf: item } })
        },
        setImportedReserveComf: (item) => {
            dispatch({ type: "IMPORTED_RESERVE_COMF", payload: { importedReserveComf: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipCancelReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_CANCEL_RESERVE_COMF", payload: { membershipCancelReserveComf: item } })
        },
    };
};

export default connect(mapStateToProps, mapDisptchToProps)(MembershipReservationPopupContainer);
